import { lazy } from "react";

export const PlatformChatsPageAsync = lazy(() => import("./PlatformChatsPage"));
